import {
    AreaSeries,
    Chart,
    ChartCanvas,
    EdgeIndicator,
    withDeviceRatio,
    withSize,
    XAxis,
    YAxis
} from "@daiver/react-financial-charts";
import { memo } from "react";
import {
    defaultChartCanvasProps,
    defaultChartEdgeIndicatorProps,
    defaultChartXAxisProps,
    defaultChartYAxisProps
} from "./liteTradeChartConstants.js";

function LiteTradeChartLine(props) {
    const {
        decimal = 3,
        lite,
    } = props;

    return <>
        <ChartCanvas
            {...defaultChartCanvasProps}
            disableInteraction={!!lite}

            ratio={props.ratio}
            width={props.width}
            data={props.data}
            xScale={props.xScale}
            xAccessor={props.xAccessor}
            xExtents={props.xExtents}
            onLoadBefore={props.getHistoricalData}
            onLoadAfter={props.getFutureData}
            margin={props.margin}
        >
            <Chart id={1} yExtentsCalculator={props.yExtentsCalculator}>
                <AreaSeries yAccessor={props.yAccessor}
                            strokeStyle={'#8192E4'}
                            strokeWidth={2}
                            fillStyle={lite ? 'rgba(129,146,228,0)' : 'rgba(129,146,228,0.1)'}
                />
                {
                    !lite && <>
                        <XAxis {...defaultChartXAxisProps}
                               showGridLines={false}
                        />
                        <YAxis {...defaultChartYAxisProps}
                               showGridLines={false}
                               tickFormat={d => d.toFixed(decimal)}
                        />
                    </>
                }
                <EdgeIndicator {...defaultChartEdgeIndicatorProps}
                               displayFormat={d => d.toFixed(decimal)}
                               yAccessor={props.yAccessor}
                               fill={d => (d.close > d.open ? "#14C679" : "#FF646C")}
                               lineStroke={d => (d.close > d.open ? "#14C679" : "#FF646C")}
                />
            </Chart>

        </ChartCanvas>

    </>
}

export default withSize({style: {minHeight: 300}})((withDeviceRatio()(memo(LiteTradeChartLine))));
